import script from "./LightboxSingle.vue?vue&type=script&lang=ts&setup=true"
export * from "./LightboxSingle.vue?vue&type=script&lang=ts&setup=true"

import "./LightboxSingle.vue?vue&type=style&index=0&id=7b13710c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b13710c"]])

export default __exports__